import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { DURATION, EASE } from "./animation-config.js";

gsap.registerPlugin(ScrollTrigger);
const EVEN_ITEM_Y = -50;

const reducedMotion = window.matchMedia(
  "(prefers-reduced-motion: reduce)",
).matches;

function getEvenItems(section) {
  return [...section.querySelectorAll(".link-tiles__item:nth-child(even)")];
}

function setInitialState(evenItems) {
  evenItems.forEach((item) => {
    gsap.set(item, { y: EVEN_ITEM_Y });
  });
}

function initLinkTiles(section) {
  const evenItems = getEvenItems(section);

  if (!evenItems.length) {
    return;
  }

  if (reducedMotion) {
    gsap.set(evenItems, { y: 0 });
    section.classList.add("is-in-view");
    return;
  }

  setInitialState(evenItems);

  ScrollTrigger.create({
    trigger: section,
    start: "top 70%",
    once: true,
    onEnter: () => {
      section.classList.add("is-in-view");

      gsap.to(evenItems, {
        y: 0,
        duration: DURATION,
        ease: EASE,
      });
    },
  });
}

document.querySelectorAll(".link-tiles").forEach(initLinkTiles);

window.addEventListener(
  "load",
  () => {
    ScrollTrigger.refresh();
  },
  { once: true },
);
